angular.module('http.users', []).factory('httpUsers', function ($http) {
  class HttpUsers {
    static getOrgUsers() {
      return $http({
        method: 'GET',
        url: 'api/users'
      }).then(function (res) {
        return res.data;
      });
    }
  }

  return HttpUsers;
});
